import { render, staticRenderFns } from "./AssessmentGroupScoreDetails.vue?vue&type=template&id=159f10e4&scoped=true"
import script from "./AssessmentGroupScoreDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupScoreDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupScoreDetails.vue?vue&type=style&index=0&id=159f10e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f10e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VTextField})
